var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCentralisedInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 397,
    viewBox: "0 0 476 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.175293 192.511L325.055 0L334.826 16.4884L9.94545 209L0.175293 192.511Z",
    fill: "#F2F2F2"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1753 208.512L396.055 16L405.825 32.4894L80.9455 225L71.1753 208.512Z",
    fill: "#F2F2F2"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133 226.103L458.219 33.3911L468 49.8957L142.78 242.609L133 226.103Z",
    fill: "#F2F2F2"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212 225.999C155.594 225.999 110 180.405 110 124C110 67.5928 155.594 22 212 22C268.406 22 314 67.5938 314 124C314 180.405 268.406 225.999 212 225.999Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.5 123.499C109.5 66.9814 155.48 21 211.999 21C268.519 21 314.499 66.9814 314.499 123.499C314.499 180.019 268.519 226 211.999 226C155.48 226 109.5 180.018 109.5 123.499ZM111.014 123.499C111.014 179.184 156.316 224.486 211.999 224.486C267.683 224.486 312.985 179.183 312.985 123.5C312.985 67.8165 267.683 22.5138 211.999 22.5138C156.316 22.5138 111.014 67.8165 111.014 123.499Z",
    fill: "#3F3D56"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193 124.5C193 114.282 201.283 105.999 211.5 106C221.718 106 230.001 114.283 230 124.499C230 134.717 221.717 143 211.501 142.999C201.283 142.999 193 134.717 193 124.5ZM211.5 106.902C201.785 106.912 193.914 114.786 193.903 124.5C193.903 134.219 201.782 142.097 211.5 142.097C221.219 142.097 229.098 134.219 229.098 124.5C229.098 114.781 221.219 106.902 211.5 106.902Z",
    fill: "#3F3D56"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177 124C177 104.67 192.671 89 212 89C231.33 89 247 104.67 247 124C247 143.33 231.329 159 212 159C192.67 158.999 177 143.328 177 124ZM212 89.8969C193.166 89.8969 177.898 105.165 177.898 124C177.898 142.834 193.165 158.102 212 158.102C230.834 158.102 246.102 142.834 246.102 124C246.083 105.174 230.826 89.9183 212 89.8969Z",
    fill: "#CCCCCC"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144 124.5C144 87.221 174.221 56.999 211.5 56.999C248.779 56.999 279 87.221 279 124.5C279 161.778 248.779 192 211.5 192C174.239 191.957 144.042 161.762 144 124.5ZM211.5 57.8887C174.712 57.8887 144.889 87.7111 144.889 124.5C144.889 161.288 174.712 191.111 211.5 191.111C248.289 191.111 278.111 161.288 278.112 124.5C278.07 87.7282 248.272 57.93 211.5 57.8887Z",
    fill: "#CCCCCC"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.001 133C210.818 133.001 209.648 132.769 208.555 132.317C207.463 131.865 206.47 131.203 205.634 130.367C204.798 129.531 204.135 128.538 203.683 127.446C203.231 126.354 202.999 125.183 203 124.001C202.999 122.818 203.231 121.647 203.683 120.555C204.135 119.462 204.798 118.47 205.634 117.634C206.47 116.798 207.462 116.135 208.555 115.683C209.647 115.231 210.818 114.999 212.001 115C213.183 114.999 214.354 115.231 215.446 115.683C216.538 116.135 217.531 116.798 218.367 117.634C219.203 118.47 219.865 119.463 220.317 120.555C220.769 121.648 221.001 122.818 221 124.001C221.001 125.183 220.769 126.353 220.317 127.446C219.865 128.538 219.202 129.53 218.366 130.366C217.53 131.202 216.538 131.865 215.446 132.317C214.353 132.769 213.183 133.001 212.001 133Z",
    fill: "#2751A5"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.001 157.001C188.818 157.002 187.647 156.77 186.555 156.318C185.462 155.866 184.469 155.203 183.633 154.367C182.797 153.531 182.134 152.538 181.683 151.445C181.231 150.353 180.999 149.182 181 147.999C180.999 146.817 181.231 145.646 181.683 144.554C182.135 143.462 182.798 142.469 183.634 141.633C184.47 140.797 185.463 140.135 186.555 139.683C187.648 139.231 188.818 138.999 190.001 139C191.183 138.999 192.354 139.231 193.446 139.683C194.539 140.135 195.531 140.798 196.367 141.634C197.203 142.47 197.866 143.462 198.318 144.555C198.77 145.647 199.002 146.818 199.001 148.001C199.002 149.183 198.77 150.354 198.318 151.446C197.866 152.539 197.203 153.531 196.367 154.367C195.531 155.203 194.539 155.866 193.446 156.318C192.354 156.77 191.183 157.002 190.001 157.001Z",
    fill: "#2751A5"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.999 153C273.883 153.001 272.777 152.782 271.746 152.355C270.714 151.928 269.777 151.302 268.987 150.513C268.198 149.723 267.572 148.786 267.145 147.754C266.718 146.723 266.499 145.617 266.5 144.501C266.499 143.384 266.718 142.278 267.145 141.246C267.572 140.215 268.198 139.277 268.987 138.488C269.776 137.698 270.714 137.072 271.746 136.645C272.777 136.218 273.883 135.999 274.999 136C276.116 135.999 277.222 136.218 278.254 136.645C279.286 137.072 280.223 137.698 281.013 138.487C281.802 139.277 282.428 140.214 282.855 141.246C283.282 142.278 283.501 143.384 283.5 144.501C283.501 145.617 283.282 146.723 282.855 147.754C282.428 148.786 281.802 149.724 281.012 150.513C280.223 151.302 279.285 151.928 278.254 152.355C277.222 152.782 276.116 153.001 274.999 153Z",
    fill: "#2751A5"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.5 128.001C210.909 128.002 210.324 127.886 209.777 127.66C209.231 127.434 208.735 127.102 208.317 126.684C207.899 126.266 207.568 125.77 207.342 125.224C207.116 124.678 207 124.092 207 123.501C206.999 122.91 207.115 122.324 207.341 121.778C207.567 121.232 207.898 120.735 208.316 120.317C208.734 119.899 209.231 119.567 209.777 119.341C210.323 119.115 210.909 118.999 211.5 118.999C212.091 118.998 212.677 119.114 213.223 119.34C213.769 119.566 214.266 119.898 214.684 120.316C215.102 120.734 215.433 121.231 215.659 121.777C215.885 122.323 216.001 122.909 216 123.5C216 124.091 215.884 124.676 215.658 125.222C215.432 125.768 215.101 126.265 214.683 126.682C214.265 127.1 213.768 127.432 213.222 127.658C212.676 127.883 212.091 127.999 211.5 127.999V128.001Z",
    fill: "#2F2E41"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.5 149C273.909 149.001 273.323 148.885 272.777 148.659C272.231 148.433 271.735 148.101 271.317 147.683C270.899 147.265 270.567 146.769 270.341 146.223C270.115 145.677 269.999 145.091 270 144.5C269.999 143.909 270.115 143.323 270.341 142.777C270.567 142.231 270.899 141.735 271.317 141.317C271.735 140.899 272.231 140.567 272.777 140.341C273.323 140.115 273.909 139.999 274.5 140C275.091 140 275.676 140.116 276.222 140.342C276.768 140.567 277.265 140.899 277.683 141.317C278.101 141.734 278.432 142.231 278.658 142.777C278.884 143.323 279 143.908 279 144.499C279 145.09 278.884 145.675 278.658 146.221C278.432 146.768 278.101 147.264 277.683 147.682C277.265 148.1 276.769 148.431 276.223 148.657C275.676 148.883 275.091 148.999 274.5 148.999V149Z",
    fill: "#2F2E41"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.5 153C189.909 153.001 189.324 152.885 188.778 152.659C188.232 152.433 187.736 152.101 187.318 151.683C186.9 151.266 186.568 150.769 186.343 150.223C186.117 149.677 186.001 149.092 186.001 148.501C186 147.91 186.116 147.325 186.341 146.778C186.567 146.232 186.898 145.736 187.316 145.317C187.734 144.899 188.23 144.567 188.776 144.341C189.322 144.115 189.908 143.999 190.499 143.999C191.09 143.998 191.675 144.114 192.221 144.34C192.768 144.566 193.264 144.898 193.682 145.316C194.1 145.734 194.431 146.23 194.657 146.776C194.883 147.322 194.999 147.908 194.999 148.499C194.999 149.09 194.883 149.675 194.657 150.222C194.432 150.768 194.1 151.264 193.682 151.682C193.265 152.1 192.768 152.431 192.222 152.657C191.676 152.883 191.091 153.001 190.5 153Z",
    fill: "#2F2E41"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4998 84.0011C25.9088 84.0016 25.3235 83.8855 24.7774 83.6595C24.2313 83.4335 23.7351 83.102 23.3173 82.684C22.8994 82.2661 22.5681 81.7698 22.3422 81.2237C22.1163 80.6775 22.0004 80.0922 22.001 79.5011C22.0002 78.9101 22.116 78.3247 22.3418 77.7785C22.5675 77.2323 22.8987 76.736 23.3165 76.3179C23.7342 75.8998 24.2303 75.5682 24.7764 75.3421C25.3224 75.116 25.9077 74.9997 26.4987 75C27.09 74.9994 27.6756 75.1154 28.2219 75.3414C28.7683 75.5674 29.2647 75.8989 29.6828 76.317C30.1009 76.7351 30.4324 77.2315 30.6584 77.7779C30.8844 78.3243 31.0004 78.9099 30.9998 79.5011C31.0001 80.0922 30.8839 80.6775 30.6578 81.2237C30.4317 81.7698 30.1001 82.2659 29.682 82.6838C29.264 83.1016 28.7676 83.433 28.2214 83.6588C27.6752 83.8847 27.0898 84.0006 26.4987 84L26.4998 84.0011Z",
    fill: "#2751A5"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.113 79.0566H37.001V78.1694H213.001V123.832H212.113V79.0566Z",
    fill: "#2F2E41"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 78.9995C15.0005 72.3722 20.3726 67 27 67C33.6273 67 38.9994 72.3722 38.9994 78.9995C38.9994 85.6268 33.6273 90.999 27 90.999C20.3726 91 15.0005 85.6268 15.0005 78.9995ZM27 67.9226C20.882 67.9226 15.923 72.8836 15.923 78.9995C15.923 85.1174 20.882 90.0764 27 90.0764C33.1179 90.0764 38.0769 85.1174 38.0769 78.9995C38.0696 72.8847 33.1148 67.9299 27 67.9226Z",
    fill: "#2F2E41"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5 198C52.909 198.001 52.3236 197.885 51.7775 197.659C51.2313 197.433 50.7351 197.102 50.3171 196.684C49.8991 196.266 49.5677 195.77 49.3417 195.224C49.1157 194.677 48.9996 194.092 49 193.501C48.9993 192.91 49.1151 192.325 49.3409 191.778C49.5667 191.232 49.898 190.736 50.3159 190.317C50.7338 189.899 51.23 189.568 51.7762 189.342C52.3224 189.116 52.9078 189 53.4989 189C54.0899 188.999 54.6753 189.115 55.2216 189.341C55.7678 189.567 56.2641 189.898 56.6822 190.316C57.1002 190.734 57.4318 191.23 57.6579 191.776C57.8841 192.322 58.0003 192.908 58 193.499C58.0006 194.09 57.8846 194.676 57.6587 195.222C57.4328 195.768 57.1013 196.265 56.6834 196.683C56.2654 197.101 55.7691 197.432 55.2229 197.658C54.6766 197.884 54.0912 198 53.5 198Z",
    fill: "#2751A5"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip36_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip37_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0005 193.001C41.0005 186.373 46.3726 181 53 181C59.6273 181 64.9994 186.373 64.9994 193.001C64.9994 199.628 59.6273 205 53 205C46.3726 205 41.0005 199.628 41.0005 193.001ZM53 181.924C46.882 181.924 41.923 186.883 41.923 193.001C41.923 199.117 46.882 204.077 53 204.077C59.1179 204.077 64.0769 199.117 64.0769 193.001C64.0696 186.886 59.1137 181.931 53 181.924Z",
    fill: "#2F2E41"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip38_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip39_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.499 102C396.908 102 396.323 101.884 395.777 101.658C395.231 101.432 394.735 101.101 394.317 100.683C393.899 100.265 393.568 99.7693 393.342 99.2233C393.116 98.6773 393 98.0922 393 97.5013C392.999 96.9101 393.115 96.3246 393.341 95.7783C393.567 95.2319 393.898 94.7354 394.316 94.3173C394.734 93.8991 395.23 93.5674 395.776 93.3412C396.322 93.115 396.908 92.9987 397.499 92.999C398.09 92.9981 398.676 93.114 399.223 93.3399C399.77 93.5659 400.266 93.8975 400.684 94.3157C401.103 94.734 401.434 95.2306 401.66 95.7773C401.886 96.3239 402.002 96.9098 402.001 97.5013C402.002 98.0924 401.885 98.6778 401.659 99.224C401.433 99.7702 401.102 100.266 400.684 100.684C400.266 101.102 399.769 101.433 399.223 101.659C398.677 101.885 398.09 102.001 397.499 102Z",
    fill: "#2751A5"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip40_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip41_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386 98.0006C386 91.3712 391.373 85.999 398.001 85.999C404.628 85.999 410 91.3712 410 97.9985C410 104.626 404.628 109.998 398.001 109.998C391.373 109.999 386 104.627 386 98.0006ZM398.001 86.9237C391.886 86.9289 386.931 91.8837 386.923 98.0006C386.923 104.117 391.882 109.076 397.999 109.076C404.116 109.076 409.076 104.117 409.076 97.9995C409.076 91.8816 404.117 86.9237 397.999 86.9237H398.001Z",
    fill: "#2F2E41"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip42_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip43_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274 99.0725L386.986 97.293L387 98.1787L274.886 99.9441V144.706H274V99.0725Z",
    fill: "#2F2E41"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip44_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip45_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 192.906H190.115V148.211H191V193.79H64.001V192.907L64 192.906Z",
    fill: "#2F2E41"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip46_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip47_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 99.4409H51V102.558H2V99.4409Z",
    fill: "#CCCCCC"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip48_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip49_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 108.441H51V111.559H2V108.441Z",
    fill: "#CCCCCC"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip50_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip51_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 117.441H51V120.559H2V117.441Z",
    fill: "#CCCCCC"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip52_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip53_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 214.409H77.999V217.591H28V214.409Z",
    fill: "#CCCCCC"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip54_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip55_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 222.909H77.999V226.09H28V222.909Z",
    fill: "#CCCCCC"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip56_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip57_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 231.409H77.999V234.59H28V231.409Z",
    fill: "#CCCCCC"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip58_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip59_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373 118.441H422.001V121.558H373V118.441Z",
    fill: "#CCCCCC"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip60_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip61_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373 127.441H422.001V130.559H373V127.441Z",
    fill: "#CCCCCC"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip62_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip63_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373 136.441H422.001V139.559H373V136.441Z",
    fill: "#CCCCCC"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip64_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip65_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.659 382.457L438.541 385L425.341 358.755L435.848 355.001L445.659 382.457Z",
    fill: "#FFB8B8"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip66_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip67_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.125 396L427.024 395.717C426.201 393.406 426.328 390.862 427.378 388.644C428.428 386.426 430.315 384.716 432.625 383.887L446.299 379.001L449.514 388L427.125 396Z",
    fill: "#2F2E41"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip68_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip69_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.547 389H393.029L389.452 359.999H400.548L400.547 389Z",
    fill: "#FFB8B8"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip70_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip71_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.941 396H378.058V395.684C378.058 393.116 379.078 390.652 380.895 388.836C382.711 387.02 385.174 386 387.743 386H402.941V396.001V396Z",
    fill: "#2F2E41"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip72_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip73_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417 207.943L413.643 201.309C413.643 201.309 401.137 204.444 400 211.693L417 207.943Z",
    fill: "#2751A5"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip74_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip75_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.177 280.2L421.476 328.748L444.576 369.6L430.776 374.999L407.377 335.4L404.376 324.599L402.577 381L390.131 380.622L384.424 327.958L393.576 279L430.176 280.2H430.177Z",
    fill: "#2F2E41"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip76_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip77_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.195 289.267C387.924 288.058 387.146 251.159 387.146 251.159C387.146 251.159 400.01 208.926 400.128 208.58L400.174 208.445L409.94 204.783C410.077 204.72 413.33 203.272 415.994 204.48C416.677 204.812 417.279 205.29 417.758 205.879C418.237 206.468 418.583 207.154 418.769 207.89C419.877 208.716 427.859 217.658 427.859 229.788L428.162 258.41L434.854 289.44L434.559 289.504C434.376 289.542 426.217 292 413.368 292C406.228 292 388.195 289.267 388.195 289.267Z",
    fill: "#3F3D56"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip78_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip79_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.5 200C401.727 200.002 399.97 199.654 398.332 198.976C396.693 198.298 395.204 197.303 393.95 196.05C392.697 194.796 391.702 193.307 391.024 191.668C390.346 190.03 389.998 188.273 390 186.5C389.998 184.727 390.346 182.97 391.024 181.332C391.702 179.693 392.697 178.204 393.95 176.95C395.204 175.697 396.693 174.702 398.332 174.024C399.97 173.346 401.727 172.998 403.5 173C405.273 172.998 407.03 173.346 408.668 174.024C410.307 174.702 411.796 175.697 413.05 176.95C414.303 178.204 415.298 179.693 415.976 181.332C416.654 182.97 417.002 184.727 417 186.5C417.002 188.273 416.654 190.03 415.976 191.668C415.298 193.307 414.303 194.796 413.05 196.05C411.796 197.303 410.307 198.298 408.668 198.976C407.03 199.654 405.273 200.002 403.5 200Z",
    fill: "#FFB8B8"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip80_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip81_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.001 244.088L399.475 276.913L396.001 261.584L423.001 244.088Z",
    fill: "black"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip82_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip83_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M381.307 277.994C382.179 277.959 383.032 277.734 383.807 277.334C384.582 276.934 385.26 276.369 385.793 275.678C386.326 274.988 386.701 274.189 386.891 273.338C387.082 272.487 387.084 271.605 386.897 270.753L404.968 259.668L394.989 255L379.36 266.242C377.948 266.65 376.736 267.561 375.952 268.804C375.168 270.047 374.868 271.534 375.108 272.983C375.348 274.433 376.112 275.743 377.255 276.667C378.398 277.59 379.84 278.063 381.307 277.994Z",
    fill: "#FFB8B8"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip84_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip85_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.416 255L387.072 259.444L392.452 268.999L399.927 262.813L393.416 255Z",
    fill: "#2751A5"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip86_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip87_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.094 256.629L404.077 240.42L398.72 218.063C398.165 215.752 398.47 213.318 399.578 211.215C400.687 209.113 402.523 207.486 404.744 206.638C406.964 205.791 409.418 205.781 411.645 206.611C413.872 207.44 415.722 209.052 416.847 211.145L416.969 211.372L421.905 244.572L397.097 269.999L390.094 256.629Z",
    fill: "#3F3D56"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip88_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip89_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.582 198.599L404.422 199C403.742 199.025 401.895 191.683 401.654 190.16C401.463 189.168 400.917 188.28 400.119 187.662C399.322 187.043 398.326 186.736 397.318 186.797C396.482 186.876 394.376 185.315 392.202 183.468C388.075 179.958 388.29 173.369 392.823 170.404C392.946 170.323 393.069 170.25 393.188 170.182C396.048 168.582 399.394 168.044 402.671 168.003C405.641 167.965 408.697 168.339 411.314 169.746C416.007 172.267 418.504 177.775 418.723 183.098C418.942 188.42 417.236 193.624 415.301 198.587L415.583 198.599",
    fill: "#2F2E41"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip90_711_38666)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip91_711_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M475.395 396.105H341.604C341.525 396.105 341.446 396.089 341.373 396.059C341.299 396.028 341.233 395.984 341.176 395.928C341.12 395.871 341.076 395.805 341.045 395.731C341.015 395.658 340.999 395.579 340.999 395.5C340.999 395.42 341.015 395.341 341.045 395.268C341.076 395.194 341.12 395.128 341.176 395.071C341.233 395.015 341.299 394.971 341.373 394.94C341.446 394.91 341.525 394.894 341.604 394.894H475.393C475.472 394.894 475.551 394.91 475.624 394.94C475.698 394.971 475.764 395.015 475.821 395.071C475.877 395.128 475.921 395.194 475.952 395.268C475.982 395.341 475.998 395.42 475.998 395.5C475.998 395.579 475.982 395.658 475.952 395.731C475.921 395.805 475.877 395.871 475.821 395.928C475.764 395.984 475.698 396.028 475.624 396.059C475.551 396.089 475.472 396.105 475.393 396.105H475.395Z",
    fill: "#3F3D56"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 209,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 209,
    fill: "white",
    transform: "translate(0.000976562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 209,
    fill: "white",
    transform: "translate(71 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 209,
    fill: "white",
    transform: "translate(71.001 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 210,
    fill: "white",
    transform: "translate(133 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 210,
    fill: "white",
    transform: "translate(133 33)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 204,
    fill: "white",
    transform: "translate(110 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 204,
    fill: "white",
    transform: "translate(110 22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 205,
    fill: "white",
    transform: "translate(109 21)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 205,
    fill: "white",
    transform: "translate(109 21)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(193 106)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(193 106)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(177 89)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(177 89)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 135,
    fill: "white",
    transform: "translate(144 57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 135,
    fill: "white",
    transform: "translate(144 57)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(203 115)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(203 115)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(181 139)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(181 139)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white",
    transform: "translate(266 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white",
    transform: "translate(266 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(207 119)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(207 119)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(270 140)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(270 140)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(186 144)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(186 144)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(22 75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(22 75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 46,
    fill: "white",
    transform: "translate(37 78)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 46,
    fill: "white",
    transform: "translate(37 78)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 67)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 67)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(49 189)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(49 189)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(41 181)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(41 181)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(393 93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(393 93)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(386 86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(386 86)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 48,
    fill: "white",
    transform: "translate(274 97)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 48,
    fill: "white",
    transform: "translate(274 96.9995)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 46,
    fill: "white",
    transform: "translate(64 148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 46,
    fill: "white",
    transform: "translate(64 148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(2 99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(2 99)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(2 108)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(2 108)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(2 117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(2 117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    fill: "white",
    transform: "translate(28 214)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    fill: "white",
    transform: "translate(28 214)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 5,
    fill: "white",
    transform: "translate(28 222)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 5,
    fill: "white",
    transform: "translate(28 222)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    fill: "white",
    transform: "translate(28 231)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 4,
    fill: "white",
    transform: "translate(28 231)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(373 118)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(373 118)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(373 127)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(373 127)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(373 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 4,
    fill: "white",
    transform: "translate(373 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 30,
    fill: "white",
    transform: "translate(425 355)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 30,
    fill: "white",
    transform: "translate(425 355)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "white",
    transform: "translate(426 379)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17,
    fill: "white",
    transform: "translate(426 379)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 29,
    fill: "white",
    transform: "translate(389 360)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 29,
    fill: "white",
    transform: "translate(389 360)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    fill: "white",
    transform: "translate(378 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 10,
    fill: "white",
    transform: "translate(378 386)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 11,
    fill: "white",
    transform: "translate(400 201)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 11,
    fill: "white",
    transform: "translate(400 201)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 102,
    fill: "white",
    transform: "translate(384 279)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 102,
    fill: "white",
    transform: "translate(384 279)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 88,
    fill: "white",
    transform: "translate(387 204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 88,
    fill: "white",
    transform: "translate(387 204)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(390 173)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(390 173)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 33,
    fill: "white",
    transform: "translate(396 244)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 33,
    fill: "white",
    transform: "translate(396 244)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 23,
    fill: "white",
    transform: "translate(375 255)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 23,
    fill: "white",
    transform: "translate(375 255)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white",
    transform: "translate(387 255)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white",
    transform: "translate(387 255)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 64,
    fill: "white",
    transform: "translate(390 206)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 64,
    fill: "white",
    transform: "translate(390 206)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 31,
    fill: "white",
    transform: "translate(389 168)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 31,
    fill: "white",
    transform: "translate(389 168)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 3,
    fill: "white",
    transform: "translate(341 394)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91_711_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 3,
    fill: "white",
    transform: "translate(341 394)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralisedInventory);
export default __webpack_public_path__ + "static/media/CentralisedInventory.637e5945fb60450c6a1fe37bf6c296e5.svg";
export { ForwardRef as ReactComponent };